
<h2 mat-dialog-title>
    {{ 'teamDefault' | translate}}
</h2>

<mat-dialog-content class="team-default-form-dialog-content">
    <h4 class="page-header page-header-top mb-3">
        <p><small>{{ 'teamDefault_description' | translate }}</small></p>
    </h4>

    <team-defaults-settings-form [team]="data.team" mode="update" (onUpdate)="onUpdate($event)"></team-defaults-settings-form>

    <p class="alert alert-warning mt-5" role="alert"><i class="far fa-exclamation-triangle"></i> {{
        'teamDefault_warning_1' | translate }}<br>
        {{ 'teamDefault_warning_2' | translate }} <a
            href="https://help.teammood.com/keeping-your-team-settings-in-sync-with-reality/batch-update-team-members-settings">
            {{ 'teamDefault_warning_3' | translate }}</a>
    </p>
</mat-dialog-content>

<mat-dialog-actions class="justify-content-center">
    <button type="button" class="btn btn-default fs-6" (click)="close()">{{'close' | translate}}
    </button>
</mat-dialog-actions>